<template>
    <div>
       I will fill up the available width and push everything else to my left and my right.
    </div>
</template>

<script>
import { vFormControls } from "@/enum";

export default {
    name: "vFormVERTICAL_SPACE",
    components: {
    },
    props: {
        element: {type: Object, required: true},
    },
    data() {
        return {
            vFormControls: vFormControls,
            height: 20,
        };
    },
    watch: {
        height() {
            this.$set(this.element, "height", this.height);
        },
    },
    beforeMount() {
        this.element.formElementType = vFormControls["HORIZONTAL_SPACE"];
        this.height = this.element.height ? this.element.height : this.height;
        this.element.isInline = true;
        if(!this.element.showAsPercentage) {
          this.$set(this.element, "showAsPercentage", false);
        }
    },
    methods: {
        save() {
            this.$emit("save", this.element);
        },
    },
};
</script>

<style scoped></style>
